module.exports = __webpack_public_path__ + "img/partOne-iPhone.12ca88fa.png";